// extracted by mini-css-extract-plugin
export default {"doc":"residencia_doc__x+VeA","body":"residencia_body__Vr3vv"};